import gql from 'graphql-tag';

import slackChannelFragment from './slackChannelFragment';

export const slackRemoteChannelsPageFragment = gql`
  fragment slackRemoteChannelsPageFragment on SlackRemoteChannelsPage {
    dokkioClass
    nextCursor
    channels {
      ...slackChannelFragment
    }
  }
  ${slackChannelFragment}
`;
export default slackRemoteChannelsPageFragment;
